/* ══ v14.4 (a): CONTINUOUS IMPROVEMENT — capture what worked and what didn't ═══════════════
   ⚠ THE NAME IS HIS RULING AND IT IS ABSOLUTE: "call it Continuous Improvement, never lessons
   learned" — the UI never shows the PMI term. The app only CAPTURES: the fishbone analysis
   happens OUTSIDE it through their own process, nothing is auto-generated, every entry is
   typed by a person. The v14.3 ledger records FACTS (who did what, minted at save); these
   entries record JUDGMENTS (why, and what to change) — never blurred.
   DATA: appMeta.improvements, ids from the self-healing high-water mark appMeta.ciSeq — BOTH
   created lazily on first add (the communications pattern, NOT the changeRequests one:
   normalizeAppMeta must never backfill this key, or a file with no entries would stop
   round-tripping byte-identically). appMeta serialises WHOLESALE, so no serialiser change;
   MERGE_SPEC carries the collection, so per-record revs, tombstoned deletes and the merge
   itself are inherited, not rebuilt. */
const _CI_TYPES = [['improve', 'Needs improvement', 'bad'], ['good', 'Worked well', 'good']];
function _ciRO() { return (appMeta && Array.isArray(appMeta.improvements)) ? appMeta.improvements : []; }
function _ciTypeMeta(v) { return _CI_TYPES.find(t => t[0] === v) || _CI_TYPES[0]; }
/* The display ref is DERIVED, never stored (two writers offline both mint "the next entry").
   ⚠ Per PROJECT, like risks — the portfolio derives against the entry's OWN project's list
   via _ciRegIdIn, never against the active project's. */
function _ciRegIdIn(list, e) { return 'CI-' + String(_mintDisplayOrd(list, e)).padStart(3, '0'); }
function _ciRegId(e) { return _ciRegIdIn(_ciRO(), e); }
function _nextCiSeq() {
  const n = _mintNextId(_ciRO(), _myWriterId(), appMeta.ciSeq);   /* the crSeq/comSeq pattern */
  appMeta.ciSeq = n;
  return n;
}
function _normCiEntry(e) {
  if (!_CI_TYPES.some(t => t[0] === e.type)) e.type = 'improve';
  ['category', 'what', 'better', 'raisedBy', 'date'].forEach(k => { if (typeof e[k] !== 'string') e[k] = ''; });
}
/* ◆3: categories are FREE TEXT, suggestions derived from those already in use, no seeded
   list — the organisation/timezone pattern. Portfolio-WIDE deliberately: the category is the
   fishbone axis, so reusing a colleague's spelling is the point. */
function _ciCategoriesInUse() {
  const seen = {};
  const take = function (list) {
    (Array.isArray(list) ? list : []).forEach(function (e) {
      if (e && !e.del && typeof e.category === 'string' && e.category.trim()) seen[e.category.trim()] = 1;
    });
  };
  (((window.__DB__ || {}).projects) || []).forEach(function (p) { take(((p || {}).appMeta || {}).improvements); });
  take(_ciRO());   /* the active project's unsaved edits, in case the two diverge pre-save */
  return Object.keys(seen).sort(function (a, b) { return a.localeCompare(b); });
}
let _ciFormOpen = false;
function openCiForm() {
  _ciFormOpen = true;
  renderImprovements();
  const w = document.getElementById('ciFWhat'); if (w) w.focus();
}
function closeCiForm() { _ciFormOpen = false; renderImprovements(); }
function ciFormType(v) {
  const host = document.getElementById('ciFType'); if (!host) return;
  host.dataset.type = (v === 'good') ? 'good' : 'improve';
  host.querySelectorAll('.ci-pill').forEach(function (p) {
    const on = p.dataset.v === host.dataset.type;
    p.className = 'ci-pill' + (on ? (host.dataset.type === 'good' ? ' on-good' : ' on-bad') : '');
  });
}
function _ciFormHtml() {
  /* The approved mockup's form, field for field: type · category · what happened · what we'd
     do differently · raised by · date. Only "what happened" is required (his ◆2 ruling). */
  return `<div class="ci-form" id="ciForm">`
    + `<p class="ci-form-ttl">New entry</p>`
    + `<div class="ci-grid">`
    + `<div class="ci-f"><label>Type</label><div class="ci-pillrow" id="ciFType" data-type="improve">`
    + `<span class="ci-pill on-bad" data-v="improve" onclick="ciFormType('improve')">Needs improvement</span>`
    + `<span class="ci-pill" data-v="good" onclick="ciFormType('good')">Worked well</span></div></div>`
    + `<div class="ci-f"><label>Category</label><input id="ciFCat" list="ciCategoryList" placeholder="e.g. Vendor management">`
    + `<span class="ci-hint">suggestions come from categories already in use — no fixed list</span></div>`
    + `<div class="ci-f ci-wide"><label>What happened</label><textarea id="ciFWhat" placeholder="what actually happened…"></textarea></div>`
    + `<div class="ci-f ci-wide"><label>What we'd do differently</label><textarea id="ciFBetter" placeholder="what you'd keep, or change, next time…"></textarea></div>`
    + `<div class="ci-f"><label>Raised by</label><input id="ciFWho" list="stakeholderList" placeholder="who saw it"></div>`
    + `<div class="ci-f"><label>Date</label><input id="ciFDate" type="date" value="${_escapeHtml(_todayISO())}"></div>`
    + `</div>`
    + `<div class="ci-form-foot"><button class="modal-cancel" onclick="closeCiForm()">Cancel</button>`
    + `<button class="modal-submit" onclick="submitCiEntry()">Add entry</button></div>`
    + `</div>`;
}
function submitCiEntry() {
  const wEl = document.getElementById('ciFWhat');
  const what = ((wEl && wEl.value) || '').trim();
  if (!what) {
    showToast('Say what happened — it’s the one required field.', { type: 'info' });
    if (wEl) wEl.focus();
    return;
  }
  if (!Array.isArray(appMeta.improvements)) appMeta.improvements = [];   /* lazy — round-trip-safe */
  const typeHost = document.getElementById('ciFType');
  const e = {
    id: _nextCiSeq(),
    type: (typeHost && typeHost.dataset.type === 'good') ? 'good' : 'improve',
    category: ((document.getElementById('ciFCat') || {}).value || '').trim(),
    what: what,
    better: ((document.getElementById('ciFBetter') || {}).value || '').trim(),
    raisedBy: ((document.getElementById('ciFWho') || {}).value || '').trim(),
    date: ((document.getElementById('ciFDate') || {}).value || '').trim() || _todayISO()
  };
  _normCiEntry(e);
  appMeta.improvements.push(e);
  _ciFormOpen = false;
  markDirty(); renderImprovements();
}
function _ciFind(id) { return _ciRO().find(x => x && !x.del && String(x.id) === String(id)); }
function _ciCardHtml(e) {
  const t = _ciTypeMeta(e.type);
  const jid = String(e.id);
  const nextLbl = (e.type === 'good') ? 'Keep doing:' : 'Next time:';
  return `<div class="ci-entry" data-id="${_escapeHtml(jid)}">`
    + `<div class="ci-lhead">`
    + `<span class="ci-ref" title="Reference — derived, per project">${_escapeHtml(_ciRegId(e))}</span>`
    + `<span class="ci-type ${t[2]}" onclick="cycleCiType(${jid})" title="Click to switch type">${_escapeHtml(t[1])}</span>`
    + `<input class="ci-cat-input" list="ciCategoryList" placeholder="category…" value="${_escapeHtml(e.category)}" onchange="editCiEntry(${jid},'category',this.value)">`
    + `<span class="ci-spacer"></span>`
    + `<input class="ci-who-input" list="stakeholderList" placeholder="raised by…" value="${_escapeHtml(e.raisedBy)}" onchange="editCiEntry(${jid},'raisedBy',this.value)">`
    + `<input type="date" class="ci-date" value="${_escapeHtml(e.date)}" onchange="editCiEntry(${jid},'date',this.value)">`
    + `<button class="rc-delete" title="Delete entry" onclick="deleteCiEntry(${jid})">&times;</button>`
    + `</div>`
    + `<div class="ci-what" contenteditable="true" spellcheck="false" data-ph="What happened…" onblur="editCiEntry(${jid},'what',this.textContent)">${_escapeHtml(e.what)}</div>`
    + `<div class="ci-next"><b>${nextLbl}</b> <span contenteditable="true" spellcheck="false" data-ph="what we'd do differently…" onblur="editCiEntry(${jid},'better',this.textContent)">${_escapeHtml(e.better)}</span></div>`
    + `</div>`;
}
function renderImprovements() {
  const host = document.getElementById('ciList'); if (!host) return;
  const formHost = document.getElementById('ciFormHost');
  const empty = document.getElementById('ciEmpty');
  const list = _ciRO().filter(e => e && !e.del);
  if (formHost) {
    /* ⚠ v15.2: an OPEN form is never rebuilt. Every re-render — a type-chip cycle on a card,
       a category edit, a delete, clicking “+ Add entry” a second time — replaced the form
       with fresh empty controls and silently wiped a half-typed draft. The one thing a
       re-render may do to an open form is leave it alone. */
    if (!_ciFormOpen) formHost.innerHTML = '';
    else if (!document.getElementById('ciForm')) formHost.innerHTML = _ciFormHtml();
  }
  /* newest first — date is the human fact, id order the tie-break (the mockup shows CI-002
     above CI-001). Tombstones already filtered. */
  const shown = list.slice().sort(function (a, b) {
    return String(b.date || '').localeCompare(String(a.date || '')) || _mergeCmpKey(b.id, a.id);
  });
  host.innerHTML = shown.map(_ciCardHtml).join('');
  if (empty) empty.style.display = (list.length || _ciFormOpen) ? 'none' : '';
  const cEl = document.getElementById('ciCount');
  if (cEl) cEl.textContent = list.length ? String(list.length) : '';
  const dl = document.getElementById('ciCategoryList');
  if (dl) dl.innerHTML = _ciCategoriesInUse().map(c => `<option value="${_escapeHtml(c)}"></option>`).join('');
}
function editCiEntry(id, field, val) {
  const e = _ciFind(id); if (!e) return;
  val = (val || '').trim();
  if (e[field] !== val) {
    e[field] = val;
    markDirty();
    if (field === 'category') renderImprovements();   /* the chip look + the suggestion pool */
  }
}
function cycleCiType(id) {
  const e = _ciFind(id); if (!e) return;
  e.type = (e.type === 'good') ? 'improve' : 'good';
  markDirty(); renderImprovements();
}
function deleteCiEntry(id) {
  const list = _ciRO();
  const idx = list.findIndex(x => x && String(x.id) === String(id));
  if (idx < 0) return;
  const e = list[idx];
  const txt = (e.what || '').trim();
  const label = txt ? '"' + _escapeHtml(txt.length > 60 ? txt.slice(0, 60) + '…' : txt) + '"' : 'this entry';
  showConfirm('Delete ' + _escapeHtml(_ciRegId(e)) + '?',
    'This improvement entry will be removed:<br><br><em>' + label + '</em><br><br>You’ll have 6 seconds to undo.',
    () => {
      const arr = _ciRO();
      const i2 = arr.findIndex(x => x && String(x.id) === String(id));
      if (i2 < 0) return;
      const removed = arr.splice(i2, 1)[0]; const removedIndex = i2;
      markDirty(); renderImprovements();
      showUndoToast('Improvement entry deleted', () => {
        appMeta.improvements.splice(removedIndex, 0, removed);
        markDirty(); renderImprovements();
        showToast('Improvement entry restored', { type: 'info' });
      });
    });
}

/* v17.0 W1: the dashboard summaries are navigation, not miniature editors.  One
   keyboard-enabled row lands by stable id; nothing attempts a text match. */
function _wireOverviewJump(row, sourceId, label, activate) {
  row.classList.add('dash-jump-row');
  row.dataset.sourceId = String(sourceId);
  row.setAttribute('role', 'button');
  row.tabIndex = 0;
  row.setAttribute('aria-label', label);
  row.addEventListener('click', activate);
  row.addEventListener('keydown', _keyActivate);
}
function openOverviewAction(actionId) {
  const exists = getAllActions().some(a => String(a.id) === String(actionId));
  if (!exists) {
    showToast('That action no longer exists. Refresh the Overview to update this list.', { type: 'warning' });
    return;
  }
  gotoActionCard(Number(actionId), { tellDontClear: true, tellAllFilters: true });
}
function openOverviewRisk(riskId) {
  const risk = (Array.isArray(RISKS) ? RISKS : [])
    .find(r => String(r.id) === String(riskId));
  if (!risk) {
    showToast('That risk no longer exists. Refresh the Overview to update this list.', { type: 'warning' });
    return;
  }
  switchTab('risks');
  const register = document.getElementById('raidRegister');
  if (register) register.open = true;
  const card = [...document.querySelectorAll('#riskList .risk-card')]
    .find(el => String(el.dataset.id) === String(riskId));
  if (!card) {
    const search = document.getElementById('riskSearchInput');
    const type = document.getElementById('riskFilterType');
    const label = _registerId(risk);
    if (search && search.value.trim())
      showToast(label + ' is hidden by your risk search. Your filter was kept.', { type: 'warning' });
    else if (type && type.value !== 'all') {
      const shown = type.options[type.selectedIndex] ? type.options[type.selectedIndex].text : type.value;
      showToast(label + ' is hidden by your “' + shown + '” risk filter. Your filter was kept.', { type: 'warning' });
    } else
      showToast(label + ' is hidden by your current RAID filters. Your filters were kept.', { type: 'warning' });
    return;
  }
  card.scrollIntoView({ block: 'center', behavior: 'smooth' });
  _flashJumpTarget(card);
}

/* ── Upcoming milestones (read-only list from ACTIONS) ───────────────────── */
function renderMilestones() {
  const host = document.getElementById('milestoneList');
  if (!host) return;
  /* Open actions with a due date. Completed + cancelled hidden. */
  const rows = getAllActions().map(a => {
    const e = edits[a.id] || {};
    const statusDisp = e.status || STATUS_DISPLAY[a.status] || a.status;
    /* ⚠⚠ v16.8 (W4): `actField`, NOT `||`. An empty edit is FALSY, so `e.due || a.due` fell
       through to the raw stored value and a date the user had CLEARED still showed here — in
       SWEEP-2's run as "2430 days overdue", while the Actions page correctly said it was not
       overdue at all. The same action, overdue on one screen and not on another, at the same
       moment. `actField` exists precisely for this class (v13.1 A06, whose comment notes that
       "the semantic `due` has always had" it) and is used two lines up for `desc`. */
    const due = _parseDueDate(actField(e, a, 'due'));
    return { id: a.id, title: (actField(e, a, 'desc') || '').trim(), status: statusDisp, due };
  }).filter(r => r.due && r.status !== 'Completed' && r.status !== 'Cancelled');

  /* Sort by due date ascending → overdue (past dates) naturally float to top. */
  rows.sort((x, y) => x.due - y.due);

  host.innerHTML = '';
  if (!rows.length) {
    host.innerHTML = '<div class="dash-list-empty">No open actions with a due date.</div>';
    return;
  }
  const today = new Date(); today.setHours(0, 0, 0, 0);
  rows.forEach(r => {
    const overdue = r.due < today;
    const row = document.createElement('div');
    row.className = 'dlc-row mil-row' + (overdue ? ' overdue' : '');
    row.innerHTML =
      '<span class="dlc-dot"></span>' +
      `<span class="mil-date">${_escapeHtml(_fmtCompactDate(r.due))}</span>` +
      `<span class="mil-id">${displayActionId(r.id)}</span>` +
      `<span class="mil-title">${_escapeHtml(r.title || '(untitled)')}</span>` +
      `<span class="mil-rel">${_escapeHtml(_relTime(r.due))}</span>`;
    _wireOverviewJump(row, r.id,
      'Open ' + displayActionId(r.id) + ' in Actions: ' + (r.title || 'untitled action'),
      () => openOverviewAction(r.id));
    host.appendChild(row);
  });
}

/* ── Key risks (read-only severity-sorted summary from RISKS) ────────────── */
function renderKeyRisks() {
  const host = document.getElementById('keyRiskList');
  if (!host) return;
  /* v3.3: shows BOTH threats and opportunities, severity-sorted (highest first).
     Threats use the lvl-* severity palette (red/amber/green); opportunities use
     the .opp-on-dashboard teal positive palette. Each row carries a small TYPE
     chip so the two read distinctly. Closed risks hidden. */
  /* ── v13.1 (A44): promoted ISSUES are not key risks ─────────────────────────────────
     An occurred threat is an issue, and the register deliberately stops showing it a
     probability × impact score at that point — once something HAS happened, "how likely is
     it" is meaningless, which is why an issue card shows SEVERITY instead. This list took
     every non-closed record and printed the live p×i score anyway, so the one number the
     register hides was the number the dashboard led with. Filtered out rather than given a
     severity column: the section is "Key risks", and issues have their own home in RAID. */
  const rows = (Array.isArray(RISKS) ? RISKS : [])
    .filter(r => (r.status || 'Open') !== 'Closed' && r.phase !== 'issue')
    .map(r => {
      const info = _riskScoreInfo(r);
      return {
        id: r.id,
        statement: (r.statement || r.title || '').trim(),
        type: (r.type === 'opportunity') ? 'opportunity' : 'threat',
        score: info.score,
        level: info.level,
      };
    })
    .sort((a, b) => b.score - a.score);

  host.innerHTML = '';
  if (!rows.length) {
    host.innerHTML = '<div class="dash-list-empty">No risks identified yet.</div>';
    return;
  }
  rows.forEach(r => {
    const row = document.createElement('div');
    row.className = 'dlc-row';
    const lvlLabel = _RISK_CAP(r.level);
    let dotCls, scoreCls, scoreText;
    if (r.type === 'opportunity') {
      dotCls = 'kr-dot opp-on-dashboard';
      scoreCls = 'kr-score opp-on-dashboard';
      const word = _OPP_WORD[r.level];
      scoreText = `Score ${r.score} · ${word}`;
    } else {
      dotCls = 'kr-dot lvl-' + r.level;
      scoreCls = 'kr-score lvl-' + r.level;
      scoreText = `Score ${r.score} · ${lvlLabel}`;
    }
    const typeChip = `<span class="kr-type-chip ${r.type}">${r.type === 'threat' ? 'T' : 'O'}</span>`;
    row.innerHTML =
      `<span class="dlc-dot ${dotCls}"></span>` +
      typeChip +
      `<span class="kr-id">${_escapeHtml(_registerId(r))}</span>` +   /* v15.2: the register's own derived ref — '#R187000001' beside a register saying R-001 broke the cross-reference on one screen */
      `<span class="kr-statement">${_escapeHtml(r.statement || '(untitled risk)')}</span>` +
      `<span class="${scoreCls}">${scoreText}</span>`;
    _wireOverviewJump(row, r.id,
      'Open ' + _registerId(r) + ' in RAID: ' + (r.statement || 'untitled risk'),
      () => openOverviewRisk(r.id));
    host.appendChild(row);
  });
}

/* ── Success Projects ────────────────────────────────────────────────────── */
/* Roll-up %: average of assigned actions' progress, where cancelled actions are
   IGNORED, completed counts as 100, others use progress (null treated as 0).
   Returns a number 0-100, or null if no countable actions. */
/* ── v8.7: WBS tree helpers ──────────────────────────────────────────────────
   Workstreams grew into a tree via one OPTIONAL field, parentId (absent = level 1,
   which is exactly the pre-v8.7 file shape — a flat file is a valid flat WBS).
   Codes (1, 1.1, 1.1.1 …) are DERIVED from tree position, never stored, so they
   renumber on add/delete/move and can never go stale. All reads are tolerant:
   an unknown/self/cyclic parentId renders as a root and is never mutated at load
   (round-trip safety) — it self-heals only if the user moves the element. */
function _wsById(id) { return WORKSTREAMS.find(w => w.id === id) || null; }
function _wsOrderValues(raw) {
  if (!Array.isArray(raw)) return null;
  const seen = new Set(), out = [];
  raw.forEach(function (id) {
    if (typeof id !== 'number' || !Number.isFinite(id) || seen.has(id)) return;
    seen.add(id); out.push(id);
  });
  return out;
}
function _wsStoredOrder() {
  return appMeta && Array.isArray(appMeta.workstreamOrder) ? appMeta.workstreamOrder : null;
}
function _wsOrderCompare(a, b, rank) {
  const ar = rank.has(a.id) ? rank.get(a.id) : Infinity;
  const br = rank.has(b.id) ? rank.get(b.id) : Infinity;
  if (ar !== br) return ar - br;
  if (ar !== Infinity) return 0;
  if (typeof a.id === 'number' && typeof b.id === 'number') return a.id - b.id;
  return String(a.id).localeCompare(String(b.id));
}
function _wsTreeIndex() {
  const byId = new Map(WORKSTREAMS.map(w => [w.id, w]));
  const rawParent = (w) => {
    const pid = w.parentId;
    return (pid == null || pid === w.id || !byId.has(pid)) ? null : pid;
  };
  /* cycle guard: walk each node's ancestor chain; any loop → treat the node as a root */
  const parent = new Map();
  WORKSTREAMS.forEach(w => {
    let pid = rawParent(w);
    const seen = new Set([w.id]);
    let cur = pid;
    while (cur != null) {
      if (seen.has(cur)) { pid = null; break; }
      seen.add(cur);
      const pw = byId.get(cur);
      cur = pw ? rawParent(pw) : null;
    }
    parent.set(w.id, pid);
  });
  const children = new Map();
  WORKSTREAMS.forEach(w => children.set(w.id, []));
  const roots = [];
  WORKSTREAMS.forEach(w => {
    const pid = parent.get(w.id);
    if (pid == null) roots.push(w); else children.get(pid).push(w);
  });
  /* P5 WS-01: absence preserves the historical array order exactly. Once the optional
     precedence list exists, every sibling group reads through it; missing live IDs follow
     listed peers in numeric order. Reading never repairs or rewrites the saved array. */
  const stored = _wsOrderValues(_wsStoredOrder());
  if (stored) {
    const rank = new Map(stored.map(function (id, i) { return [id, i]; }));
    roots.sort(function (a, b) { return _wsOrderCompare(a, b, rank); });
    children.forEach(function (list) { list.sort(function (a, b) { return _wsOrderCompare(a, b, rank); }); });
  }
  const depth = new Map(), code = new Map();
  const walk = (list, prefix, d) => list.forEach((w, i) => {
    const c = prefix ? prefix + '.' + (i + 1) : String(i + 1);
    code.set(w.id, c); depth.set(w.id, d);
    walk(children.get(w.id), c, d + 1);
  });
  walk(roots, '', 1);
  return { roots, children, depth, code, parent };
}
function _wsDepthFirstIds(idx) {
  const ix = idx || _wsTreeIndex(), out = [];
  const emit = function (w) {
    out.push(w.id);
    (ix.children.get(w.id) || []).forEach(emit);
  };
  ix.roots.forEach(emit);
  return out;
}
function _wsMaterialiseOrder(idx) {
  const live = _wsDepthFirstIds(idx || _wsTreeIndex());
  const stored = _wsOrderValues(_wsStoredOrder());
  if (!stored) appMeta.workstreamOrder = live.slice();
  else {
    appMeta.workstreamOrder = stored.slice();
    live.forEach(function (id) { if (!appMeta.workstreamOrder.includes(id)) appMeta.workstreamOrder.push(id); });
  }
  return appMeta.workstreamOrder;
}
function _wsAppendOrderId(id, idx) {
  const order = _wsMaterialiseOrder(idx);
  if (!order.includes(id)) order.push(id);
}
function _wsSubtree(id, idx) {
  /* the element + all descendants, depth-first (idx optional) */
  const ix = idx || _wsTreeIndex();
  const out = [];
  const rec = (wid) => {
    const w = _wsById(wid); if (!w) return;
    out.push(w);
    (ix.children.get(wid) || []).forEach(c => rec(c.id));
  };
  rec(id);
  return out;
}
function _wsSubtreeHeight(id, idx) {
  const ix = idx || _wsTreeIndex();
  const rec = (wid) => 1 + Math.max(0, ...(ix.children.get(wid) || []).map(c => rec(c.id)));
  return rec(id);
}
function _wsSubtreeActionIds(project, idx) {
  const set = new Set();
  _wsSubtree(project.id, idx).forEach(w => (w.actionIds || []).forEach(aid => set.add(aid)));
  return [...set];
}
function _wsValidMoveTargets(id) {
  /* targets for "Move…": not the element itself, not its own subtree, and the landing
     depth must keep the whole moved subtree within 3 levels */
  const idx = _wsTreeIndex();
  const sub = new Set(_wsSubtree(id, idx).map(w => w.id));
  const h = _wsSubtreeHeight(id, idx);
  return WORKSTREAMS.filter(w => !sub.has(w.id) && (idx.depth.get(w.id) + h) <= 3);
}
function _wsCascadeDelete(rootId) {
  /* Q-g: cascade — splice the element AND all descendants out (bottom-up, so indices
     stay valid) and return one restore fn that reinstates the WHOLE subtree at the
     original positions (top-down). Actions are untouched — only groupings go. */
  const subtree = _wsSubtree(rootId);
  if (!subtree.length) return null;
  const removals = subtree
    .map(w => ({ w, at: WORKSTREAMS.indexOf(w) }))
    .sort((a, b) => b.at - a.at);
  removals.forEach(r => WORKSTREAMS.splice(r.at, 1));
  const restores = removals.slice().sort((a, b) => a.at - b.at);
  return () => { restores.forEach(r => WORKSTREAMS.splice(r.at, 0, r.w)); };
}

function _wsOrderDeleteContext(rootId, idx) {
  const ix = idx || _wsTreeIndex();
  const ids = _wsSubtree(rootId, ix).map(function (w) { return w.id; });
  const flat = _wsDepthFirstIds(ix), first = flat.findIndex(function (id) { return id === rootId; });
  return {
    hadOrder: Array.isArray(_wsStoredOrder()),
    stored: Array.isArray(_wsStoredOrder()) ? _wsStoredOrder().slice() : null,
    ids: ids,
    anchors: (first > 0 ? flat.slice(0, first) : []).filter(function (id) { return !ids.includes(id); }).reverse()
  };
}
function _wsOrderApplyDelete(context) {
  if (!context || !context.hadOrder) return;
  if (!WORKSTREAMS.length) { delete appMeta.workstreamOrder; return; }
  const removed = new Set(context.ids);
  appMeta.workstreamOrder = context.stored.filter(function (id) { return !removed.has(id); });
}
function _wsOrderRestoreDelete(context) {
  if (!context) return;
  const current = _wsStoredOrder();
  if (!context.hadOrder && !current) return;
  const removed = new Set(context.ids);
  const base = (current ? current.slice() : (context.stored || []).slice())
    .filter(function (id) { return !removed.has(id); });
  /* If deleting the last live item cleared the key, keep any dormant entries that existed
     before it. Later-added IDs already in the current list retain their positions. */
  (context.stored || []).forEach(function (id) { if (!removed.has(id) && !base.includes(id)) base.push(id); });
  let at = 0;
  const anchor = context.anchors.find(function (id) { return base.includes(id); });
  if (anchor !== undefined) at = base.indexOf(anchor) + 1;
  const restored = context.ids.filter(function (id, i, all) { return all.indexOf(id) === i; });
  base.splice(at, 0, ...restored);
  appMeta.workstreamOrder = base;
}
function _wsPlaceAfterDestinationSiblings(order, movedId, parentId, idx) {
  const ix = idx || _wsTreeIndex();
  const siblings = (parentId == null ? ix.roots : (ix.children.get(parentId) || []))
    .filter(function (w) { return w.id !== movedId; });
  const from = order.indexOf(movedId);
  if (from >= 0) order.splice(from, 1);
  let at = 0;
  if (siblings.length) {
    const anchor = siblings[siblings.length - 1].id;
    at = order.indexOf(anchor) + 1;
  } else if (parentId != null && order.includes(parentId)) {
    at = order.indexOf(parentId) + 1;
  }
  order.splice(Math.max(0, at), 0, movedId);
}

function _wsProgressSummary(project) {
  /* v8.7: progress rolls up — an element's % reads over its own actions plus all
     descendants' (the display is derived; nothing stored). */
  const ids = _wsSubtreeActionIds(project);
  let sum = 0, n = 0;
  ids.forEach(id => {
    const a = getAllActions().find(x => x.id === id);
    if (!a) return;                       /* deleted action — skip (also auto-unlinked elsewhere) */
    const e = edits[id] || {};
    const status = e.status || STATUS_DISPLAY[a.status] || a.status;
    if (status === 'Cancelled') return;   /* cancelled ignored */
    let p;
    if (status === 'Completed') p = 100;
    else p = (typeof e.progress === 'number') ? e.progress : 0;
    sum += p; n += 1;
  });
  return { percent: n ? Math.round(sum / n) : null, count: n };
}
function _projectProgress(project) {
  /* Historical numeric wrapper retained for downstream callers; P5 headers use the summary. */
  return _wsProgressSummary(project).percent;
}
/* Which project (if any) currently owns a given action id. Returns the project or null. */
/* ── v12.2 (W3): actions that will never be WBS items ───────────────────────────
   OPT-OUT, his call at scoping ("opt out is great"): every action is a WBS candidate until
   marked. Opt-IN was rejected because a NEW action would default to invisible, so coverage
   would read 100% while nothing was assigned.
   The flag is a LAZY key on the action RECORD - clearing DELETES it, so a project that never
   used it round-trips byte-identically (the allocationPct / plannedStart / archived precedent).
   ⚠ getAllActions() returns REFERENCES into ACTIONS/newActions, so mutating what it hands
   back mutates the stored record - which is the point here. */
function _actionIsNoWbs(actionId) {
  const a = getAllActions().find(x => x && x.id === actionId);
  return !!(a && a.noWbs);
}
function _setActionNoWbs(actionId, on) {
  const a = getAllActions().find(x => x && x.id === actionId);
  if (!a) return false;
  if (on) a.noWbs = true; else delete a.noWbs;   /* clearing DELETES the key, never sets false */
  markDirty();
  return true;
}
function _projectOwningAction(actionId) {
  return WORKSTREAMS.find(p => Array.isArray(p.actionIds) && p.actionIds.includes(actionId)) || null;
}
/* v3.2: prune deleted action ids from all projects (called on action delete + render). */
function pruneProjectActionLinks() {
  const validIds = new Set(getAllActions().map(a => a.id));
  let changed = false;
  WORKSTREAMS.forEach(p => {
    if (!Array.isArray(p.actionIds)) { p.actionIds = []; return; }
    const before = p.actionIds.length;
    p.actionIds = p.actionIds.filter(id => validIds.has(id));
    if (p.actionIds.length !== before) changed = true;
  });
  return changed;
}
function _wsActiveProjectUid() {
  const db = window.__DB__;
  const project = db && Array.isArray(db.projects)
    ? db.projects.find(c => c && c.appMeta === appMeta) : null;
  return project && typeof project.uid === 'string' && project.uid ? project.uid : null;
}
function _wsExpandedSet(uid, create) {
  if (!uid) return null;
  let set = _wsExpandedByProject.get(uid);
  if (!set && create) { set = new Set(); _wsExpandedByProject.set(uid, set); }
  return set || null;
}
function _wsRememberRenderedExpansions(host) {
  if (!_wsRenderedProjectUid || !host) return;
  const set = _wsExpandedSet(_wsRenderedProjectUid, true);
  host.querySelectorAll('.ws-card[data-id]').forEach(card => {
    const id = Number(card.dataset.id);
    if (!Number.isFinite(id)) return;
    if (card.classList.contains('expanded')) set.add(id); else set.delete(id);
  });
  /* IDs absent from this render deliberately remain. A cascade delete can still be undone,
     and a safe model refresh can make a temporarily absent record visible again. */
}
function _wsSetExpanded(id, expanded, uid) {
  const key = uid || _wsActiveProjectUid();
  const set = _wsExpandedSet(key, true);
  if (!set || !Number.isFinite(Number(id))) return;
  if (expanded) set.add(Number(id)); else set.delete(Number(id));
}
function _wsEditorDescriptor(host) {
  const el = document.activeElement;
  if (!host || !el || !host.contains(el)) return null;
  const card = el.closest('.ws-card[data-id]');
  if (!card) return null;
  let kind = null;
  if (el.classList.contains('ws-title')) kind = 'title';
  else if (el.classList.contains('ws-scope')) kind = 'scope';
  else if (el.classList.contains('wbs-date-start')) kind = 'start';
  else if (el.classList.contains('wbs-date-finish')) kind = 'finish';
  else if (el.classList.contains('ws-lifecycle')) kind = 'lifecycle';
  return kind ? { id: Number(card.dataset.id), kind } : null;
}
function _wsEditorForDescriptor(host, descriptor) {
  if (!host || !descriptor) return null;
  const classes = { title: '.ws-title', scope: '.ws-scope',
                    start: '.wbs-date-start', finish: '.wbs-date-finish', lifecycle: '.ws-lifecycle' };
  const card = host.querySelector(`.ws-card[data-id="${descriptor.id}"]`);
  return card && classes[descriptor.kind] ? card.querySelector(classes[descriptor.kind]) : null;
}
function _wsFocusWithoutScroll(el, caretToEnd) {
  if (!el || typeof el.focus !== 'function') return;
  try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  if (!caretToEnd || !el.isContentEditable) return;
  const range = document.createRange();
  range.selectNodeContents(el); range.collapse(false);
  const selection = window.getSelection();
  if (selection) { selection.removeAllRanges(); selection.addRange(range); }
}
function _wsHeaderTop(id) {
  const card = document.querySelector(`#spList .ws-card[data-id="${Number(id)}"]`);
  const header = card && card.querySelector('.ws-header');
  return header ? header.getBoundingClientRect().top : null;
}
function _wsRestoreHeaderTop(id, priorTop) {
  if (!Number.isFinite(priorTop)) return;
  const currentTop = _wsHeaderTop(id);
  if (!Number.isFinite(currentTop)) return;
  const delta = currentTop - priorTop;
  if (Math.abs(delta) > 0.5) window.scrollBy({ top: delta, behavior: 'instant' });
}
function _wsReorderBind(projectUid) {
  if (!_wbsReorderReady || !projectUid) return null;
  return _reorderUiBind('workstream', projectUid);
}
function _wsReorderEditing(projectUid) {
  return _wbsReorderReady && _reorderUiEditing('workstream', projectUid);
}
function _wsCanEdit() {
  if (!_progressControllerReady) return false;
  try { return _dbLoadOk && !_fileAlertBlocked(); }
  catch (e) { return false; }
}
function _wsHasMovablePair(idx) {
  const ix = idx || _wsTreeIndex();
  if (ix.roots.length > 1) return true;
  let pair = false;
  ix.children.forEach(function (list) { if (list.length > 1) pair = true; });
  return pair;
}
function _wsReorderToolbarHtml(projectUid, idx) {
  if (!_wbsReorderReady || !_wsCanEdit() || !projectUid) return '';
  const editing = _wsReorderEditing(projectUid);
  const allowed = editing || _wsHasMovablePair(idx);
  return `<button type="button" class="ov-btn wbs-reorder-toggle" data-order-kind="workstream"`
    + ` data-programme-id="${_escapeHtml(projectUid)}" aria-label="${editing ? 'Done reordering' : 'Reorder'} work breakdown"`
    + ` aria-disabled="${allowed ? 'false' : 'true'}" onclick="_reorderUiToggle(event,this)">${editing ? 'Done' : 'Reorder'}</button>`;
}
function _wsOrderMoveState(workstream, idx) {
  const ix = idx || _wsTreeIndex();
  const pid = ix.parent.get(workstream.id);
  const group = pid == null ? ix.roots : (ix.children.get(pid) || []);
  const at = group.findIndex(function (w) { return w.id === workstream.id; });
  return { up: at > 0, down: at >= 0 && at < group.length - 1 };
}
function _wsOrderMoveButtonsHtml(workstream, idx, projectUid) {
  const state = _wsOrderMoveState(workstream, idx);
  const id = String(workstream.id), title = (workstream.title || '(untitled)').trim() || '(untitled)';
  function button(dir, allowed) {
    const label = (dir === 'up' ? 'Move up ' : 'Move down ') + title;
    return `<button type="button" class="wbs-order-move" data-order-kind="workstream"`
      + ` data-programme-id="${_escapeHtml(projectUid)}" data-order-id="${_escapeHtml(id)}" data-order-dir="${dir}"`
      + ` aria-label="${_escapeHtml(label)}" title="${_escapeHtml(label)}" aria-disabled="${allowed ? 'false' : 'true'}"`
      + ` onkeydown="event.stopPropagation()" onclick="_listOrderMove(event,this)">${dir === 'up' ? '↑' : '↓'}</button>`;
  }
  return `<span class="wbs-order-moves">${button('up', state.up)}${button('down', state.down)}</span>`;
}
function _wsOrderMoveHtml(workstream, idx, projectUid) {
  const buttons = _wsReorderEditing(projectUid)
    ? _wsOrderMoveButtonsHtml(workstream, idx, projectUid) : '';
  return `<span class="wbs-order-move-slot" data-order-id="${_escapeHtml(String(workstream.id))}"`
    + `${buttons ? '' : ' aria-hidden="true"'}>${buttons}</span>`;
}
function _wsReorderSyncUi(projectUid) {
  if (!_wbsReorderReady) return;
  const uid = projectUid || _wsActiveProjectUid() || '';
  const idx = _wsTreeIndex();
  const toolbar = document.getElementById('wbsToolbar');
  if (toolbar) toolbar.innerHTML = _wsReorderToolbarHtml(uid, idx);
  const host = document.getElementById('spList');
  if (!host) return;
  const editing = _wsReorderEditing(uid);
  host.querySelectorAll('.wbs-order-move-slot').forEach(function (slot) {
    const w = _wsById(Number(slot.dataset.orderId));
    slot.innerHTML = editing && w ? _wsOrderMoveButtonsHtml(w, idx, uid) : '';
    if (slot.innerHTML) slot.removeAttribute('aria-hidden'); else slot.setAttribute('aria-hidden', 'true');
  });
}
function _wsOrderMove(event, button) {
  if (!button || button.getAttribute('aria-disabled') === 'true' || !_wsCanEdit()) return;
  const uid = button.dataset.programmeId || '';
  if (!_wsReorderEditing(uid)) return;
  const id = Number(button.dataset.orderId), dir = button.dataset.orderDir;
  const w = _wsById(id); if (!w) return;
  const idx = _wsTreeIndex(), pid = idx.parent.get(id);
  const group = pid == null ? idx.roots : (idx.children.get(pid) || []);
  const at = group.findIndex(function (item) { return item.id === id; });
  const to = dir === 'up' ? at - 1 : at + 1;
  if (at < 0 || to < 0 || to >= group.length) return;
  const otherId = group[to].id;
  const anchorTop = _wsHeaderTop(id);
  const order = _wsMaterialiseOrder(idx);
  const fromIndex = order.indexOf(id), toIndex = order.indexOf(otherId);
  if (fromIndex < 0 || toIndex < 0) return;
  const swap = order[fromIndex]; order[fromIndex] = order[toIndex]; order[toIndex] = swap;
  markDirty();
  _wbsRepaintMembership({ anchorId:id, anchorTop:anchorTop });
  const next = document.querySelector(`.wbs-order-move[data-order-id="${CSS.escape(String(id))}"][data-order-dir="${CSS.escape(dir)}"]`);
  if (next) { next.scrollIntoView({ block:'nearest' }); next.focus({ preventScroll:true }); }
}
function _initWbsReorderController() {
  if (_wbsReorderBound) return;
  _wbsReorderBound = true;
  const section = document.getElementById('workstreamsSection');
  if (!section) return;
  section.addEventListener('toggle', function () {
    const uid = _wsActiveProjectUid() || '';
    if (section.open) _wsReorderBind(uid);
    else if (_reorderUiMatches('workstream', uid)) _reorderUiReset();
    _wsReorderSyncUi(uid);
  });
}
function renderWorkstreams(options) {
  const host = document.getElementById('spList');
  const empty = document.getElementById('spEmpty');
  if (!host) return;
  const retainedEditor = _wsEditorDescriptor(host);
  if (retainedEditor && document.activeElement
      && typeof document.activeElement.blur === 'function') document.activeElement.blur();
  _wsRememberRenderedExpansions(host);
  const projectUid = _wsActiveProjectUid();
  if (_wbsReorderReady) _wsReorderBind(projectUid);
  pruneProjectActionLinks();
  renderWbsCoverage();
  const idx = _wsTreeIndex();
  const toolbar = document.getElementById('wbsToolbar');
  if (toolbar) toolbar.innerHTML = _wsReorderToolbarHtml(projectUid || '', idx);
  /* summary count: plain N while the breakdown is flat; "N elements · M workstreams" once nested */
  const cEl = document.getElementById('wbsCount');
  if (cEl) {
    const total = WORKSTREAMS.length, roots = idx.roots.length;
    cEl.textContent = !total ? '' : (total === roots ? String(total)
      : `${total} elements · ${roots} workstream${roots === 1 ? '' : 's'}`);
  }
  host.innerHTML = '';
  if (!WORKSTREAMS.length) {
    if (empty) empty.style.display = '';
    _wsRenderedProjectUid = projectUid;
    renderOverallProgress();
    return;
  }
  if (empty) empty.style.display = 'none';
  /* v8.7: depth-first tree walk (was a flat forEach) */
  const emit = (w) => {
    host.appendChild(_buildProjectCard(w, idx));
    (idx.children.get(w.id) || []).forEach(emit);
  };
  idx.roots.forEach(emit);
  _wsRenderedProjectUid = projectUid;
  const expanded = _wsExpandedSet(projectUid, false);
  host.querySelectorAll('.ws-card[data-id]').forEach(card => {
    const id = Number(card.dataset.id);
    card.classList.toggle('expanded', !!(expanded && expanded.has(id)));
  });
  const restoredEditor = _wsEditorForDescriptor(host, retainedEditor);
  _wsFocusWithoutScroll(restoredEditor,
    !!(restoredEditor && restoredEditor.isContentEditable));
  if (options && options.anchorId != null) {
    _wsRestoreHeaderTop(options.anchorId, options.anchorTop);
  }
  /* v9.0: the Schedule view derives from the same tree + dates + action roll-up,
     and every mutation funnels through here (incl. refreshAll on action edits) —
     so this one hook keeps the Gantt current. */
  if (typeof renderSchedule === 'function') renderSchedule();
  renderOverallProgress();
}
/* v8.7: coverage strip — the WBS 100% rule. X of Y actions are assigned somewhere in
   the breakdown; each stray gets a one-click chip that opens the element picker. */
function renderWbsCoverage() {
  const host = document.getElementById('wbsCov');
  if (!host) return;
  const all = getAllActions();
  if (!WORKSTREAMS.length || !all.length) { host.style.display = 'none'; host.innerHTML = ''; return; }
  const assigned = new Set();
  WORKSTREAMS.forEach(w => (w.actionIds || []).forEach(id => assigned.add(id)));
  /* v12.2 (W3): an action marked "not a WBS item" leaves BOTH the chip list and the
     denominator, which is what makes 100% reachable and honest.
     ⚠⚠ v16.5 (a2): ...BUT ONLY IF IT IS NOT ASSIGNED. This is the LAST line of defence on the
     one number in this app that could read HIGHER than the truth. An action that is both
     assigned and flagged is a contradiction (◆E: the two states must never contradict each
     other); the entry paths can no longer create one and the load heal clears the ones already
     on disk - but neither helps a contradiction that arrives some other way, e.g. merged in
     from a colleague still on an older shell. ⚠ THE COUNT ITSELF MUST NOT BE ABLE TO LIE:
     measured on v16.4 this showed "1 of 2" with BOTH actions assigned, i.e. coverage could
     reach 100% while real, countable work sat outside the denominator.
     ⚠ ASSIGNED WINS, matching _wbsPillHtml's long-standing precedence, so the number agrees
     with the pill the user is looking at. An unassigned marked action is excluded exactly as
     before - that half of v12.2's rule is untouched. */
  const cand = all.filter(a => !(a && a.noWbs && !assigned.has(a.id)));
  const excluded = all.length - cand.length;
  const unassigned = cand.filter(a => !assigned.has(a.id));
  const n = cand.length, k = n - unassigned.length;
  const pct = n ? Math.round((k / n) * 100) : 0;
  host.style.display = '';
  /* Stated, not hidden: the numbers must be explainable, or an excluded action looks lost. */
  const naNote = excluded ? `<span class="wbs-cov-ok">${excluded} not a WBS item</span>` : '';
  /* Every action excluded: no denominator to divide by, so say so instead of showing 0/0. */
  if (!n) { host.innerHTML = `<span>No actions are WBS candidates</span>` + naNote; return; }
  let htmlStr = `<span class="wbs-cov-num">${k} / ${n}</span><span>actions assigned to the breakdown</span>`
    + `<span class="wbs-cov-bar"><i style="width:${pct}%"></i></span>`;
  if (unassigned.length) {
    htmlStr += `<span class="wbs-cov-warn">${unassigned.length} unassigned:</span>`
      + unassigned.map(a => {
          const e = edits[a.id] || {};
          const d = ((actField(e, a, 'desc') || '').trim() || '(untitled)');
          const short = d.length > 38 ? d.slice(0, 38) + '…' : d;
          return `<button type="button" class="wbs-cov-chip" title="Assign to a breakdown element" onclick="openWbsAssign(${a.id})">${displayActionId(a.id)} ${esc(short)} → assign…</button>`;
        }).join('');
  } else {
    htmlStr += `<span class="wbs-cov-ok">100% — every action has a home</span>`;
  }
  host.innerHTML = htmlStr + naNote;
}
function _wsLifecycleClass(value) {
  return PROG_LIFECYCLE.some(function (o) { return o[0] === value; }) ? ' lc-' + value : '';
}
function _wsLifecycleSelectHtml(workstream, depth) {
  const valid = PROG_LIFECYCLE.some(function (o) { return o[0] === workstream.lifecycle; });
  const value = valid ? workstream.lifecycle : '';
  const options = [['','Not set']].concat(PROG_LIFECYCLE);
  return `<select class="lc-badge ws-lifecycle${_wsLifecycleClass(value)}"`
    + ` aria-label="${depth === 1 ? 'Workstream status' : 'Item status'}" data-workstream-id="${workstream.id}"`
    + `${_wsCanEdit() ? '' : ' disabled'} onchange="setWorkstreamLifecycle(${workstream.id},this.value)">`
    + options.map(function (o) { return `<option value="${o[0]}"${value === o[0] ? ' selected' : ''}>${o[1]}</option>`; }).join('')
    + `</select>`;
}
function setWorkstreamLifecycle(id, value) {
  if (!_wsCanEdit()) return false;
  const workstream = _wsById(Number(id)); if (!workstream) return false;
  const valid = PROG_LIFECYCLE.some(function (o) { return o[0] === value; });
  const before = Object.prototype.hasOwnProperty.call(workstream, 'lifecycle') ? workstream.lifecycle : undefined;
  if (valid) workstream.lifecycle = value; else delete workstream.lifecycle;
  const after = Object.prototype.hasOwnProperty.call(workstream, 'lifecycle') ? workstream.lifecycle : undefined;
  if (before === after) return false;
  markDirty();
  renderWorkstreams();
  return true;
}
function _wsProgressHelpButtonHtml(workstream, projectUid) {
  if (!_progressControllerReady || !projectUid) return '';
  return `<button type="button" class="ov-info-i progress-help-trigger ws-progress-help"`
    + ` data-progress-help-kind="workstream" data-project-uid="${_escapeHtml(projectUid)}"`
    + ` data-workstream-id="${_escapeHtml(String(workstream.id))}"`
    + ` aria-label="How workstream progress is calculated" aria-expanded="false">i</button>`;
}
function _buildProjectCard(project, idx) {
  const ix = idx || _wsTreeIndex();
  const depth = ix.depth.get(project.id) || 1;
  const wbsCode = ix.code.get(project.id) || '';
  const isLeaf = !(ix.children.get(project.id) || []).length;
  const card = document.createElement('div');
  /* v8.7: indent by level (visual only; capped at 3) */
  card.className = 'ws-card wbs-lvl' + Math.min(depth, 3);
  card.dataset.id = project.id;

  const summary = _wsProgressSummary(project);
  const pct = summary.percent;             /* subtree roll-up since v8.7 */
  const pctText = (pct === null) ? '—' : pct + '%';
  const pctWidth = (pct === null) ? 0 : pct;
  const count = Array.isArray(project.actionIds) ? project.actionIds.length : 0;   /* OWN actions */
  const projectUid = _wsActiveProjectUid() || '';
  const progressLabel = pct === null
    ? 'Calculated progress: no actions to include'
    : `Calculated progress: ${pct}% from ${summary.count} action${summary.count === 1 ? '' : 's'}`;

  /* Header (click toggles expand) */
  const header = document.createElement('div');
  header.className = 'ws-header';
  header.innerHTML =
    '<div class="ws-chevron"><svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4.5 7L9 11.5L13.5 7"/></svg></div>' +
    `<span class="wbs-code" title="WBS code (derived — renumbers automatically)">${_escapeHtml(wbsCode)}</span>` +
    `<span class="ws-title" contenteditable="true" spellcheck="false">${_escapeHtml(project.title || '')}</span>` +
    ((isLeaf && depth >= 2) ? '<span class="wbs-wp" title="Lowest-level element — a work package">work pkg</span>' : '') +
    `<span class="ws-count">${count} action${count === 1 ? '' : 's'}</span>` +
    _wsLifecycleSelectHtml(project, depth) +
    '<span class="ws-progress-wrap">' +
      '<span class="ws-progress-label">Action progress</span>' +
      `<span class="ws-progress-bar"><span class="ws-progress-fill" style="width:${pctWidth}%"></span></span>` +
      `<span class="ws-progress-pct" aria-label="${_escapeHtml(progressLabel)}">${pctText}</span>` +
      _wsProgressHelpButtonHtml(project, projectUid) +
    '</span>' +
    (_wbsReorderReady ? _wsOrderMoveHtml(project, ix, projectUid) : '');
  /* Expand toggle — but not when clicking/editing the title */
  header.addEventListener('click', (e) => {
    if (e.target.closest('button, input, select, a, [contenteditable="true"]')) return;
    const expanded = !card.classList.contains('expanded');
    card.classList.toggle('expanded', expanded);
    _wsSetExpanded(project.id, expanded);
  });
  const titleEl = header.querySelector('.ws-title');
  _onBlurCommit(titleEl, () => {
    const v = (titleEl.textContent || '').trim();
    if (v !== (project.title || '')) { project.title = v; markDirty(); }
  });
  titleEl.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); titleEl.blur(); } });
  card.appendChild(header);

  /* Body */
  const body = document.createElement('div');
  body.className = 'ws-body';

  const scopeLabel = document.createElement('div');
  scopeLabel.className = 'ws-sub-label';
  /* v8.7: tree controls — add a child (until depth 3), reparent, cascade remove */
  scopeLabel.innerHTML = '<span>Scope</span>' +
    '<span class="wbs-ctls">' +
      (depth < 3 ? `<button class="wbs-ctl" title="Add a child element beneath this one" onclick="addChildWorkstream(${project.id})">+ Sub-item</button>` : '') +
      `<button class="wbs-ctl" title="Move this element (and its sub-items) elsewhere in the breakdown" onclick="openWbsMove(${project.id})">Move…</button>` +
      `<button class="ws-ar-remove wbs-del" title="Remove this element${isLeaf ? '' : ' and its sub-items'}" aria-label="Remove element" onclick="deleteWorkstream(${project.id})">&times;</button>` +
    '</span>';
  body.appendChild(scopeLabel);

  const scope = document.createElement('div');
  scope.className = 'ws-scope';
  scope.contentEditable = 'true';
  scope.spellcheck = false;
  scope.textContent = project.scope || '';
  _onBlurCommit(scope, () => {
    const v = (scope.textContent || '').trim();
    if (v !== (project.scope || '')) { project.scope = v; markDirty(); }
  });
  body.appendChild(scope);

  /* v9.0: planned dates — the ONLY writable home for the schedule (the Schedule
     section below is a read-only view of these). Clearing an input DELETES the
     key, so an unplanned element serialises with no schedule keys at all
     (pre-v9.0 shape). Reads are tolerant; nothing is rewritten at load. */
  const dates = document.createElement('div');
  dates.className = 'wbs-dates';
  dates.innerHTML =
    `<span class="wbs-dates-lbl">Planned</span>` +
    `<span class="sched-row"><span class="sched-label">Start</span><input type="date" class="sched-date wbs-date-start" value="${_escapeHtml(typeof project.plannedStart === 'string' ? project.plannedStart : '')}"></span>` +
    `<span class="sched-row"><span class="sched-label">Finish</span><input type="date" class="sched-date wbs-date-finish" value="${_escapeHtml(typeof project.plannedFinish === 'string' ? project.plannedFinish : '')}"></span>` +
    `<span class="sched-hint wbs-date-hint" hidden>Planned finish is before the start date.</span>`;
  const _syncDateHint = () => {
    const s = (typeof project.plannedStart === 'string') ? project.plannedStart : '';
    const f = (typeof project.plannedFinish === 'string') ? project.plannedFinish : '';
    const h = dates.querySelector('.wbs-date-hint');
    if (h) h.hidden = !(s && f && f < s);   /* ISO strings compare chronologically (Q6 idiom) */
  };
  const _wireDate = (cls, key) => {
    const inp = dates.querySelector('.' + cls);
    const commit = () => {
      const v = inp.value || '';
      if (v) { if (project[key] !== v) { project[key] = v; markDirty(); } }
      else if (key in project) { delete project[key]; markDirty(); }
      _syncDateHint();
      if (typeof renderSchedule === 'function') renderSchedule();
    };
    inp.addEventListener('change', commit);
    inp.addEventListener('blur', commit);
  };
  _wireDate('wbs-date-start', 'plannedStart');
  _wireDate('wbs-date-finish', 'plannedFinish');
  _syncDateHint();
  body.appendChild(dates);

  const calculated = document.createElement('div');
  calculated.className = 'ws-calculated';
  calculated.textContent = `Calculated from ${summary.count} action${summary.count === 1 ? '' : 's'}`;
  body.appendChild(calculated);

  const actionsLabel = document.createElement('div');
  actionsLabel.className = 'ws-sub-label';
  actionsLabel.innerHTML = `<span>Assigned actions (${count})</span>` +
    `<button class="ws-assign-btn" onclick="openActionPicker(${project.id})">+ Assign actions</button>`;
  body.appendChild(actionsLabel);

  const listWrap = document.createElement('div');
  if (!count) {
    listWrap.innerHTML = '<div class="ws-no-actions">No actions assigned yet.</div>';
  } else {
    project.actionIds.forEach(aid => {
      const a = getAllActions().find(x => x.id === aid);
      if (!a) return;
      const e = edits[aid] || {};
      const status = e.status || STATUS_DISPLAY[a.status] || a.status;
      const prog = (status === 'Completed') ? 100 : (typeof e.progress === 'number' ? e.progress : null);
      const progText = (status === 'Cancelled') ? '—' : (prog === null ? '0%' : prog + '%');
      const r = document.createElement('div');
      r.className = 'ws-action-row';
      r.title = 'Open this action on the Actions tab';
      r.innerHTML =
        `<span class="ws-ar-id">${displayActionId(aid)}</span>` +
        `<span class="ws-ar-title">${_escapeHtml((actField(e, a, 'desc') || '').trim() || '(untitled)')}</span>` +
        `<span class="ws-ar-status">${_escapeHtml(status)}</span>` +
        `<span class="ws-ar-prog">${progText}</span>` +
        `<button class="ws-ar-remove" data-action-id="${aid}" title="Remove from workstream" aria-label="Remove ${displayActionId(aid)} from workstream">×</button>`;
      r.querySelector('.ws-ar-remove').onclick = (ev) => { ev.stopPropagation(); unassignActionFromProject(project.id, aid); };
      /* v9.0: the row is a click-through to the action (the × keeps its own job) */
      r.addEventListener('click', (ev) => {
        if (ev.target.closest('.ws-ar-remove')) return;
        gotoActionCard(aid);
      });
      listWrap.appendChild(r);
    });
  }
  body.appendChild(listWrap);
  card.appendChild(body);
  return card;
}
function addWorkstream() {
  const idx = _wsTreeIndex();
  const p = { id: _nextWsSeq(), title: '', scope: '', actionIds: [], assignments: [] };   /* v16.8 (W5) */
  _wsAppendOrderId(p.id, idx);
  WORKSTREAMS.push(p);
  markDirty();
  _wsSetExpanded(p.id, true);
  renderWorkstreams();
  /* Expand the new card and focus its title for immediate naming. */
  const card = document.querySelector(`#spList .ws-card[data-id="${p.id}"]`);
  if (card) {
    card.scrollIntoView({ block: 'nearest' });
    const t = card.querySelector('.ws-title');
    if (t) t.focus();
  }
}
/* v8.7: add a child element beneath a parent (depth-capped at 3). Children carry the
   one new optional field, parentId — old records are never touched. */
function addChildWorkstream(parentId) {
  const idx = _wsTreeIndex();
  if (!_wsById(parentId)) return;
  if ((idx.depth.get(parentId) || 1) >= 3) { showToast('Maximum depth is 3 levels', { type: 'info' }); return; }
  const p = { id: _nextWsSeq(), title: '', scope: '', actionIds: [], assignments: [], parentId: parentId };   /* v16.8 (W5) */
  _wsAppendOrderId(p.id, idx);
  WORKSTREAMS.push(p);
  markDirty();
  _wsSetExpanded(p.id, true);
  renderWorkstreams();
  const card = document.querySelector(`#spList .ws-card[data-id="${p.id}"]`);
  if (card) {
    card.scrollIntoView({ block: 'center' });
    const t = card.querySelector('.ws-title');
    if (t) t.focus();
  }
}
function deleteWorkstream(projectId) {
  const w = _wsById(projectId);
  if (!w) return;
  const _wsName = w.title || w.name || '';
  const label = _wsName ? '"' + _escapeHtml(_wsName) + '"' : 'this element';
  /* v8.7 (Q-g): cascade — the whole subtree goes together, and undo restores it whole */
  const kidCount = _wsSubtree(projectId).length - 1;
  const kids = kidCount ? ` and its ${kidCount} sub-item${kidCount === 1 ? '' : 's'}` : '';
  /* ⚠ v16.5 (a4): THE OLD WORDING PROMISED SOMETHING IT DID NOT DELIVER - "Actions attached to
     any of them stay put — only the grouping is removed." The ACTIONS do stay put; their
     ASSIGNMENT does not, because it lives on the grouping and dies with it. The user was told
     nothing would change about their actions and then watched every one turn "unassigned" -
     very likely WHY this was reported as a bug rather than as normal behaviour. ⚠ Same shape
     as v16.2's "Open now" pill: words describing one thing while the code does another. */
  showConfirm('Remove workstream?',
    'This removes the ' + label + ' grouping' + kids + '. <strong>The actions themselves are kept</strong>, but they lose their place in the breakdown and become unassigned — you can give them a new home afterwards.<br><br>You\'ll have 6 seconds to undo.',
    () => {
      const orderContext = _wsOrderDeleteContext(projectId);
      const restore = _wsCascadeDelete(projectId);
      if (!restore) return;
      _wsOrderApplyDelete(orderContext);
      markDirty(); _wbsRepaintMembership();   /* v16.5 (a1) */
      showUndoToast(kidCount ? 'Workstream + sub-items removed' : 'Workstream removed', () => {
        restore();
        _wsOrderRestoreDelete(orderContext);
        markDirty(); _wbsRepaintMembership();   /* v16.5 (a1): undo repaints the cards too */
        showToast('Workstream restored', { type: 'info' });
      });
    });
}
/* ── v8.7: WBS element picker (one modal, two jobs) ───────────────────────────
   mode 'move'   → reparent an element (targets exclude its own subtree + depth cap)
   mode 'assign' → give an unassigned action a home (any element — Q-d) */
let _wbsPick = null;
function openWbsMove(id) {
  const w = _wsById(id); if (!w) return;
  const idx = _wsTreeIndex();
  const targets = _wsValidMoveTargets(id);
  const sel = document.getElementById('wbsPickTarget');
  sel.innerHTML = '<option value="">(top level — a workstream)</option>' +
    targets.map(t => `<option value="${t.id}">${esc(idx.code.get(t.id) || '')} ${esc(t.title || '(untitled)')}</option>`).join('');
  document.getElementById('wbsPickTitle').textContent = 'Move "' + (w.title || '(untitled)') + '"';
  document.getElementById('wbsPickLabel').textContent = 'Move to';
  document.getElementById('wbsPickGo').textContent = 'Move';
  /* v12.2 (W3): ONE modal, two jobs - the opt-out belongs to assign mode only. BOTH entry
     points must set this, or move mode inherits whatever assign left behind. */
  const naBtn = document.getElementById('wbsPickNa');
  if (naBtn) naBtn.hidden = true;
  _wbsPick = { mode: 'move', id };
  document.getElementById('wbsPickOverlay').classList.add('open');
}
function openWbsAssign(actionId) {
  if (!WORKSTREAMS.length) return;
  const idx = _wsTreeIndex();
  const sel = document.getElementById('wbsPickTarget');
  const flat = [];
  const emit = (w) => { flat.push(w); (idx.children.get(w.id) || []).forEach(emit); };
  idx.roots.forEach(emit);
  sel.innerHTML = flat.map(t => `<option value="${t.id}">${esc(idx.code.get(t.id) || '')} ${esc(t.title || '(untitled)')}</option>`).join('');
  const a = getAllActions().find(x => x.id === actionId);
  const e = edits[actionId] || {};
  document.getElementById('wbsPickTitle').textContent = 'Assign ' + displayActionId(actionId) + ' — ' + (((actField(e, a, 'desc') || '').trim() || '(untitled)').slice(0, 50));   /* v15.2: derived number */
  document.getElementById('wbsPickLabel').textContent = 'Assign to';
  document.getElementById('wbsPickGo').textContent = 'Assign';
  /* v12.2 (W3): the opt-out lives in the picker the pill already opens - no new modal. The
     label flips with the current state, so the same button also REVERSES it. */
  const naBtn = document.getElementById('wbsPickNa');
  if (naBtn) {
    naBtn.textContent = _actionIsNoWbs(actionId) ? 'Make it a WBS candidate' : 'Not a WBS item';
    naBtn.hidden = false;
  }
  _wbsPick = { mode: 'assign', id: actionId };
  document.getElementById('wbsPickOverlay').classList.add('open');
}
function closeWbsPick() {
  document.getElementById('wbsPickOverlay').classList.remove('open');
  _wbsPick = null;
}
function confirmWbsPick() {
  if (!_wbsPick) return;
  const sel = document.getElementById('wbsPickTarget');
  const v = sel.value;
  if (_wbsPick.mode === 'move') {
    const w = _wsById(_wbsPick.id);
    if (w) {
      const idx = _wsTreeIndex();
      const currentParent = idx.parent.get(w.id);
      const target = v === '' ? null : Number(v);
      const valid = target == null || _wsValidMoveTargets(w.id).some(function (t) { return t.id === target; });
      if (valid && currentParent !== target) {
        const order = _wsMaterialiseOrder(idx);
        if (target == null) delete w.parentId;             /* back to level 1 — key removed */
        else w.parentId = target;
        _wsPlaceAfterDestinationSiblings(order, w.id, target, idx);
        markDirty();
      }
    }
  } else if (_wbsPick.mode === 'assign') {
    const target = _wsById(Number(v));
    if (target) {
      if (!Array.isArray(target.actionIds)) target.actionIds = [];
      if (!target.actionIds.includes(_wbsPick.id)) target.actionIds.push(_wbsPick.id);
      /* v12.2 (W3, ◆E): assigning a marked action CLEARS the flag - the two states must never
         contradict each other. Deletes the key rather than setting it false. */
      _setActionNoWbs(_wbsPick.id, false);
      markDirty();
    }
  }
  closeWbsPick();
  renderWorkstreams();
  renderRaci();
  render();   /* v12.2 (W3): the action CARDS carry the pill, so they must repaint as well */
}
/* v12.2 (W3): set or clear the opt-out, then repaint both places it shows - the coverage
   strip (inside renderWorkstreams) and the action cards (render). */
function wbsPickToggleNa() {
  if (!_wbsPick || _wbsPick.mode !== 'assign') return;
  const id = _wbsPick.id;
  _setActionNoWbs(id, !_actionIsNoWbs(id));
  closeWbsPick();
  renderWorkstreams();
  render();
}
/* ── v16.5 (a1): ONE repaint set for every change of WBS membership ────────────────────
   ⚠ THE PILL LIVES ON THE ACTION CARD, NOT ON THE WORKSTREAM CARD. Three of the four paths
   that change membership repainted only the workstream card, so an action card went on
   showing a pill for a workstream that had just been deleted - which is what he reported as
   "weird pill states". confirmWbsPick was the only one that got it right, and its own v12.2
   comment already said why: "the action CARDS carry the pill, so they must repaint as well".
   ⚠ FOUR CALL SITES THAT MUST AGREE IS WHAT CAUSED THIS. There is now one helper and no
   opinion about which renderers a membership change needs - add a path, call this.
   ⚠ renderRaci() is in the set because a workstream carries RACI assignments; dropping it
   would trade this defect for its neighbour. */
function _wbsRepaintMembership(options) {
  renderWorkstreams(options);
  renderRaci();
  render();            /* the action cards - the half that was missing */
}
function unassignActionFromProject(projectId, actionId) {
  const p = WORKSTREAMS.find(x => x.id === projectId);
  if (!p) return;
  const before = Array.isArray(p.actionIds) ? p.actionIds.slice() : [];
  const at = before.indexOf(actionId);
  if (at < 0) return;
  const after = before.filter(id => id !== actionId);
  const focusActionId = after[at] != null ? after[at] : after[at - 1];
  const anchorTop = _wsHeaderTop(projectId);
  p.actionIds = after;
  markDirty();
  _wbsRepaintMembership({ anchorId: projectId, anchorTop });
  const card = document.querySelector(`#spList .ws-card[data-id="${Number(projectId)}"]`);
  const destination = card && (focusActionId != null
    ? card.querySelector(`.ws-ar-remove[data-action-id="${Number(focusActionId)}"]`)
    : null);
  _wsFocusWithoutScroll(destination || (card && card.querySelector('.ws-assign-btn')), false);
  _wsRestoreHeaderTop(projectId, anchorTop);
  showToast('Action removed from this workstream.', { type: 'info' });
}

